import React from "react";
import { useClick, useData } from "state/hooks";
import MuiListItem from "@material-ui/core/ListItem";
import cn from "classnames";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";
import StatusIcon from "./StatusIcon";
import ListItemText from "@material-ui/core/ListItemText";
import { MessageTime } from "components/DateDiff";
//import PropTypes from 'prop-types';

export function FormResponseListItem(props) {
    const { selected, id } = props;
    const data = useData(props);
    const onClick = useClick(props);
    return (
        <MuiListItem
            onClick={onClick}
            button
            className={cn({
                "list-item": true,
                "is-active": selected === id,
            })}
        >
            <ListItemAvatar>
                <Avatar>
                    <StatusIcon status={data.status_code} />
                </Avatar>
            </ListItemAvatar>
            <ListItemText
                primary={data.subject}
                secondary={
                    <span>
                        <MessageTime value={data.created_at} />, {data.email}
                    </span>
                }
            />
        </MuiListItem>
    );
}

FormResponseListItem.propTypes = {};

FormResponseListItem.defaultProps = {};

export default FormResponseListItem;
